/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_mobile_analytics_app_id": "d0d1f91b3378440897ef34361b655edf",
    "aws_mobile_analytics_app_region": "us-west-2",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "d0d1f91b3378440897ef34361b655edf",
            "region": "us-west-2"
        }
    },
    "aws_appsync_graphqlEndpoint": "https://ryr4faeedrfllj37ocl3rwfhfe.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-kakfzwvmfjhezegy3zoqfnyfxq",
    "aws_cloud_logic_custom": [
        {
            "name": "payment",
            "endpoint": "https://0jimy9nhdk.execute-api.ap-northeast-1.amazonaws.com/osaka",
            "region": "ap-northeast-1"
        }
    ],
    "aws_cognito_identity_pool_id": "ap-northeast-1:950cfe61-c67b-400a-b5f6-1bafd95d0f50",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_8ZROg8Iqo",
    "aws_user_pools_web_client_id": "1cnhpghlvfbd60g5l3hvmq8o9",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "antecessor114153-osaka",
    "aws_user_files_s3_bucket_region": "ap-northeast-1"
};


export default awsmobile;
